module.exports = __webpack_public_path__ + "static/media/17.e489e88c.png";